import * as yup from 'yup';

export const schema = yup.object({
  nome_pc: yup.string().required(),
});
